import React, {useEffect, useState} from "react";
import {
    Avatar,
    CircularProgress,
    Grid, Link, makeStyles, Paper,
    Typography,
} from "@material-ui/core";
import Controls from "../../components/controls/Controls";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import {connect} from "react-redux";
import {loginUser, refreshToken} from "../../redux/login/AuthServerActions";
import {NOTIFICATION_TIME} from "../../helpers/NotificationHelper";
import Notification from "../../components/Notification";
import {closeNotification} from "../../redux/login/AuthViewActions";
import {Alert} from "@material-ui/lab";
import {USER_KEY} from "../../helpers/TokenHelper";

const initialFormValue = {
    username: '',
    password: ''
}
const useStyle = makeStyles((theme) => ({
    backgroundImage: {
        backgroundImage: 'url(img/login-background.png)',
        height: '100vh',
        backgroundPosition: "center",
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    },
    paper: {
        margin: theme.spacing(8, 2),
        padding: theme.spacing(8, 2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        //  backgroundColor: theme.palette.white,
        border: '1px solid grey',
        borderRadius: '6px',
        backgroundColor: theme.palette.type === 'light' ? 'rgba(255, 255, 255, 0.6)' : 'rgba(0, 0, 0, 0.4)'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,

        background: 'linear-gradient(90deg, rgba(252,205,128,1) 0%, rgba(209,122,142,1) 55%, rgba(220,159,174,1) 100%)'
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(2),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    loginButtonWrapper: {
        margin: theme.spacing(1),
        position: 'relative',

    },
    btnProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }
}));

function LoginPage(props) {

    const {
        auth,
        loginUser,
        closeNotification,
        refreshToken
    } = props;
    const [formValues, setFormValues] = useState(initialFormValue);
    const [errors, setErrors] = useState({});
    const [validateOnChange, setValidateOnChange] = useState(false);

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem(USER_KEY));
        if (user) {
            //Try logging in user automatically
            refreshToken(user.refreshToken);
        }
    }, [])

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setValidateOnChange(true)
        if (!validateForm()) return;
        loginUser(formValues);
    }

    const handleInputChange = e => {
        const {name, value} = e.target;
        setFormValues({
            ...formValues,
            [name]: value
        })
        if (validateOnChange) {
            validateForm({
                [name]: value
            })
        }
    }

    const validateForm = (fieldValues = formValues) => {
        let temp = {...errors};
        if ('username' in fieldValues) {
            temp.username = fieldValues.username ? '' : 'Please enter your username';
        }

        if ('password' in fieldValues) {
            temp.password = fieldValues.password ? '' : 'Please enter your password';
        }

        setErrors({
            ...temp
        })

        if (fieldValues === formValues)
            return Object.values(temp).every(x => x === "")
    }

    function handleNotificationClose() {
        closeNotification();
    }

    const classes = useStyle();

    return (
        <div>
            {/*<div className={classes.backgroundImage}></div>*/}
            {

                <Grid container component="main" className={classes.backgroundImage}>

                    <Grid item xs={false} sm={4} md={8}/>
                    <Grid item xs={12} sm={8} md={4} elevation={6}>
                        <Paper className={classes.paper}>
                            <Avatar className={classes.avatar}>
                                <LockOutlinedIcon/>
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                Sign in to Nexus Pickup
                            </Typography>

                            <form noValidate className={classes.form} onSubmit={handleFormSubmit}>
                                <Controls.Input variant="outlined"
                                                margin="normal"
                                                required
                                                fullWidth
                                                id="username"
                                                label="Username"
                                                name="username"
                                                onChange={handleInputChange}
                                                error={errors.username}
                                                inputProps={{maxLength: 10}}
                                                autoFocus
                                />
                                <Controls.Input
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    type="password"
                                    id="password"
                                    onChange={handleInputChange}
                                    error={errors.password}
                                    autoComplete="current-password"
                                />

                                {auth.error &&
                                <Alert severity="error">{auth.error}</Alert>
                                }

                                <div className={classes.loginButtonWrapper}>
                                    <Controls.Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit}
                                        text='Sign In'
                                        disabled={auth.loading}
                                        size='large'/>
                                    {auth.loading && <CircularProgress size={24} className={classes.btnProgress}/>}
                                </div>
                            </form>
                            <Notification
                                open={auth.notification.show}
                                type={auth.notification.type}
                                message={auth.notification.message}
                                handleClose={handleNotificationClose}
                                position={{vertical: 'top', horizontal: 'center'}}
                                hideDuration={auth.notification.type === 'error' ? null : NOTIFICATION_TIME}
                            />
                            <Typography
                                color='textSecondary'>
                                &copy; {new Date().getFullYear() + ' '}
                                <Link href={'https://nexuserp.com.au'}>NexusERP</Link>
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
            }
        </div>
    );
}

const mapStateToProps = state => {
    return {
        auth: state.auth
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loginUser: (data) => loginUser(data),
        closeNotification: closeNotification(),
        refreshToken: (refToken) => refreshToken(refToken)
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps()
)(LoginPage);
